import './locales/i18n';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/main.scss';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { Spinner } from 'react-bootstrap';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './app/store';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

// Suppress ResizeObserver loop limit exceeded error
const resizeObserverErr = 'ResizeObserver loop limit exceeded';
const resizeObserverErr2 =
  'ResizeObserver loop completed with undelivered notifications';
const originalError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (
    message === resizeObserverErr ||
    message === resizeObserverErr2 ||
    (typeof message === 'string' && message.includes(resizeObserverErr2))
  ) {
    return true;
  }
  if (originalError) {
    return originalError(message, source, lineno, colno, error);
  }
  return false;
};

const originalHandler = window.onunhandledrejection;
window.onunhandledrejection = event => {
  if (
    event.reason &&
    (event.reason.message === resizeObserverErr ||
      event.reason.message === resizeObserverErr2)
  ) {
    event.preventDefault();
    return;
  }
  if (originalHandler) {
    originalHandler.call(window, event);
  }
};

// Create a root.
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      <React.StrictMode>
        <Suspense
          fallback={
            <div
              className="d-flex w-100 justify-content-center align-items-center"
              style={{ height: '100vh' }}
            >
              <div className="d-flex gap-16 align-items-center">
                <Spinner animation="border" /> Kirjaudutaan sisään...
              </div>
            </div>
          }
        >
          <App />
        </Suspense>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
